import { render, staticRenderFns } from "./BtnNaoAceitar.vue?vue&type=template&id=62bce666"
import script from "./BtnNaoAceitar.vue?vue&type=script&lang=js"
export * from "./BtnNaoAceitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports